module.exports = __webpack_public_path__ + "img/icon-notificaciones.e7cd5f2d.svg";